import {
  Center,
  Group,
  NavLink,
  SimpleGrid,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import {
  IconCalendar,
  IconChevronRight,
  IconDog,
  IconLogout,
  IconMail,
  IconPhoto,
  IconUser,
  IconUserSearch,
  IconUsersGroup,
} from "@tabler/icons-react";
import { FancyLoader } from "@/components/FancyLoader";
import { LinkButton } from "@/components/LinkButton";
import { NotificationPrompt } from "@/components/NotificationPrompt";
import { Portrait } from "@/components/Portrait";
import { useTrainerProfileDisplay } from "@/hooks/useProfileDisplay";
import { TrainerRoutes, UniversalRoutes, useNavigator } from "@/routers/routes";
import { useSignOut } from "@/utils/signout";

export const trainerProfileNavLinks = [
  {
    label: "Personal Information",
    icon: IconUser,
    route: UniversalRoutes.PROFILE.PERSONAL_INFO,
  },
  {
    label: "Public Profile",
    icon: IconUserSearch,
    route: TrainerRoutes.PROFILE.PUBLIC_PROFILE,
  },
  {
    label: "Gallery",
    icon: IconPhoto,
    route: TrainerRoutes.PROFILE.GALLERY,
  },
  {
    label: "Schedules",
    icon: IconCalendar,
    route: TrainerRoutes.PROFILE.SCHEDULES,
  },
  {
    label: "Individual Sessions",
    icon: IconDog,
    route: TrainerRoutes.PROFILE.SESSION_TYPES,
  },
  {
    label: "Group Classes",
    icon: IconUsersGroup,
    route: TrainerRoutes.PROFILE.GROUP_CLASS_TYPES,
  },
  {
    label: "Booking Settings",
    icon: IconUserSearch,
    route: TrainerRoutes.PROFILE.BOOKING_SETTINGS,
  },
  {
    label: "Notifications",
    icon: IconMail,
    route: UniversalRoutes.PROFILE.NOTIFICATIONS,
  },
  {
    label: "Sign out",
    icon: IconLogout,
    signOut: true as const,
  },
];

export const AccountSettings = () => {
  const { navigator } = useNavigator();
  const { profile } = useTrainerProfileDisplay();
  const signOut = useSignOut();

  if (!profile) {
    return <FancyLoader />;
  }

  return (
    <Stack>
      <Title order={1}>Profile Settings</Title>
      <SimpleGrid cols={1}>
        <Stack>
          <Center>
            <Portrait profile={profile} size="8em" />
          </Center>
          <Center>
            <LinkButton
              href={UniversalRoutes.PROFILE.PORTRAIT}
              variant="outline"
              color="black"
            >
              Change
            </LinkButton>
          </Center>
        </Stack>
      </SimpleGrid>
      <NotificationPrompt />
      {trainerProfileNavLinks.map((link, index) => (
        <NavLink
          key={index}
          pl={0}
          p={0}
          mt="xs"
          label={
            <Group justify="space-between" wrap="nowrap" w="100%">
              <Text size="1.5em">{link.label}</Text>
            </Group>
          }
          leftSection={<link.icon size="1.5em" />}
          rightSection={
            <IconChevronRight
              size="1.5em"
              stroke={1.5}
              className="mantine-rotate-rtl"
            />
          }
          onClick={link.signOut ? signOut : navigator({ path: link.route })}
        />
      ))}
    </Stack>
  );
};
